import styled from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import { phoneMaxWidth } from 'themes/styles/dimensions'

export const Text = styled.h1`
	display: flex;
	font-size: 24px;
	color: ${colors.darkPurple};
	margin: 60px 0 30px;
	justify-content: center;

  @media (max-width: ${phoneMaxWidth}px) {
    font-size: 16px;
  };
`

export const NumberItem = styled.span`
	color: ${colors.blue};
`
